module.exports = __webpack_public_path__ + "img/logo-white.1a5cc7c2.svg";